// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';

import {Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import {getImageUrl} from '../../../../../utils/image_provider';

type Props = {
  id: number,
  imageId?: string,
  name?: string,
  text: string,
  number: string | number,
};

const useStyles = makeStyles(theme => ({
  row: {
    width: '100%',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
  },
  centerContent: {
    width: '100%',
    display: 'flex',
  },
  product: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    // margin: theme.spacing(0, 1),
  },
  productNumber: {
    color: colors.grey600,
    width: 24,
    minWidth: 24,
  },
  productImage: {
    height: 44,
    width: 44,
    objectFit: 'cover',
    borderRadius: '12px',
    marginRight: theme.spacing(2),
  },
  productName: {
    color: colors.grey800,
    fontSize: '0.875rem',
    display: '-webkit-box',
    lineClamp: 2,
    overflow: 'hidden',
    '-webkit-box-orient': 'vertical',
    marginRight: theme.spacing(2),
  },
  productSalesCount: {
    color: colors.grey900,
    marginLeft: 'auto',
    textAlign: 'center',
    fontSize: '0.75rem',
    '& b': {
      fontSize: '0.875rem',
    },
  },
}));

export default function RowItemProducts(props: Props) {
  const {id, imageId, name, text, number} = props;
  const classes = useStyles();

  return (
    <div className={classes.product}>
      <Typography className={classes.productNumber}>{id + 1}.</Typography>
      <img
        className={classes.productImage}
        src={getImageUrl(imageId ? imageId : null)}
        alt=""
      />
      <Typography className={classes.productName}>{name}</Typography>
      <Typography className={classes.productSalesCount}>
        <b>{number}</b>
        <br /> {text}
      </Typography>
    </div>
  );
}

RowItemProducts.propTypes = {
  id: PropTypes.number.isRequired,
  imageId: PropTypes.string,
  name: PropTypes.string,
  text: PropTypes.string.isRequired,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
